

















/* eslint-disable @typescript-eslint/no-non-null-assertion */
import Vue from 'vue'
import { mapState } from 'vuex'

export default Vue.extend({
  name: 'AgreementTohobank',
  computed: {
    ...mapState(['serviceName'])
  }
})
